import React from 'react';
interface Feature {
  title: string;
  description: string;
}
const features: Feature[] = [{
  title: 'Flexible Payment Options',
  description: 'Choose payment amounts based on your finances — your home equity covers what remains, giving you full control over your private mortgage repayment.'
}, {
  title: 'Quick Access to Funds',
  description: "Unlock up to 75% of your property's value, with mortgage approval and funding in as little as 48 hours — no lengthy bank delays."
}, {
  title: 'No Credit Requirement',
  description: "Get access to equity-based mortgage solutions without worrying about credit score limitations — we focus on your home's value, not your credit history."
}, {
  title: 'Expert Guidance',
  description: 'A dedicated mortgage advisor will answer your questions, explain your options, and guide you through every step of the lending process.'
}];
export function ProcessSteps() {
  return <section className="w-full relative overflow-hidden bg-gradient-to-br from-[#07493a] to-[#1a6b55] py-20 px-4" data-id="element-253">
      {/* Subtle radial yellow/gold glow overlay */}
      <div className="absolute inset-0 pointer-events-none" style={{
      background: 'radial-gradient(ellipse 60% 80% at 80% 20%, rgba(201,169,97,0.15) 0%, rgba(201,169,97,0.06) 40%, transparent 70%)'
    }} aria-hidden="true" data-id="element-254" />

      <div className="max-w-7xl mx-auto relative z-10" data-id="element-255">
        <div className="text-center mb-16" data-id="element-256">
          {/* Decorative dots */}

          <h2 className="text-4xl md:text-5xl font-serif text-white mb-6 font-[500]" data-id="element-257">
            How Equity Rich Works
          </h2>
          <p className="text-xl text-gray-300 max-w-3xl mx-auto mb-4" data-id="element-258">
            Explore mortgage solutions tailored to give you financial freedom
            and peace of mind with straightforward, reliable features.
          </p>
          <p className="text-lg text-gray-400 max-w-3xl mx-auto" data-id="element-259">
            We offer first and second mortgages strictly based on your equity
            and location of the property.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6" data-id="element-260">
          {features.map(feature => <div key={feature.title} className="bg-white/10 backdrop-blur-sm border border-white/15 rounded-2xl p-6 transition-all duration-300 hover:bg-white/15 hover:border-white/25 hover:shadow-lg hover:shadow-accent/5" data-id="element-261">
              <h3 className="text-lg font-serif font-[500] text-white mb-3" data-id="element-262">
                {feature.title}
              </h3>
              <p className="text-gray-300 text-sm leading-relaxed" data-id="element-263">
                {feature.description}
              </p>
            </div>)}
        </div>
      </div>
    </section>;
}